<template>
    <div class="flex flex-col gap-2 bg-white shadow rounded p-4">
        <div class="grid grid-cols-2">
            <p>ID:</p>
            <p>{{ detail?.id }}</p>
        </div>
        <div class="grid grid-cols-2">
            <p>{{ $t('page.date') }}:</p>
            <p>{{ detail?.date_created }}</p>
        </div>
        <div class="grid grid-cols-2">
            <p>{{ $t('page.store') }}:</p>
            <p>{{ detail?.store.name }}</p>
            
        </div>
        <div class="grid grid-cols-2">
            <p>{{ $t('page.status') }}:</p>
            <p :class="statusmap[detail?.status]['color']">{{ statusmap[detail?.status][$i18n.locale] }}</p>
            
        </div>
        <div class="grid grid-cols-2">
            <p>{{ $t('page.deliveryType') }}:</p>
            <p v-if="detail?.delivery_type == 0">{{ $t('page.usual') }}</p>
            <p v-else-if="detail?.delivery_type == 1">{{ $t('page.express') }}</p>
            <p v-else-if="detail?.delivery_type == 2">{{ $t('page.pickup') }}</p>
        </div>
        <div class="grid grid-cols-2">
            <p>{{ $t('page.paymentMethod') }}:</p>
            <p v-if="detail?.payment_method == 0">{{ $t('page.cash') }}</p>
            <p v-else-if="detail?.payment_method == 1">{{ $t('page.terminal') }}</p>
            <p v-else-if="detail?.payment_method == 2">{{ $t('page.online') }}</p>
        </div>
        <div class="grid grid-cols-2">
            <p>{{ $t('page.note') }}:</p>
            <p>{{ detail?.note }}</p>
        </div>
        <hr>
        <div class="my-4">

            <div class="text-center font-bold text-xl mb-2">
                {{ $t('page.products') }}
            </div>
            <div>
                <div class="grid grid-cols-5">
                    <p class="font-bold border-y p-2 border-[#f4f4f4]">{{ $t('page.name') }}</p>
                    <p class="font-bold border-y p-2 border-[#f4f4f4]">{{ $t('page.size') }}</p>
                    <p class="font-bold border-y p-2 border-[#f4f4f4]">{{ $t('page.price') }}</p>
                    <p class="font-bold border-y p-2 border-[#f4f4f4]">{{ $t('page.quantity') }}</p>
                    <p class="font-bold border-y p-2 border-[#f4f4f4]">{{ $t('page.totalPrice') }}</p>
                </div>
                <div v-for="item in detail?.cart_items" :key="item.id" class="grid grid-cols-5 border-t border-[#f4f4f4]">
                    <p class="p-2">{{ item?.product?.name }}</p>
                    <p class="p-2">{{ item?.product?.size  }}</p>
                    <p class="p-2">{{ item?.total_price / item?.quantity }}</p>
                    <p class="p-2">{{ item?.quantity }}</p>
                    <p class="p-2">{{ item?.total_price  }}</p>
                </div>
              
            </div>
        </div>

        <hr>

        <div class="grid grid-cols-2">
            <p class="font-bold text-lg">{{ $t('page.delivery') }}:</p>
            <p class="font-bold text-lg">{{ detail?.delivery_price }} TMT</p>
        </div>
        <div class="grid grid-cols-2">
            <p class="font-bold text-lg">{{ $t('page.totalPrice') }}:</p>
            <p class="font-bold text-lg">{{ detail?.total_price }} TMT</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        detail: {
            type: Object,
            default: {}
        }
    },
    data(){
        return {
            statusmap: {
                
                0: {
                    tk: 'Sebetde',
                    ru: 'В корзине',
                    color: ''
                },
                1: {
                    tk: 'Garaşylýar',
                    ru: 'Ожидается',
                    color: 'text-yellow-600'
                },
                2: {
                    tk: 'Ugradyldy',
                    ru: 'Отправлено',
                    color: 'text-orande-500'
                },
                3: {
                    tk: 'Eltip berildi',
                    ru: 'Доставлено',
                    color: 'text-green-500'
                },
                4: {
                    tk: 'Ýatyryldy',
                    ru: 'Отменено',
                    color: 'text-red-500'
                }
            }
        }
    },
}
</script>